export type TextLink = { start: number; end: number; href: string }

export type LinkActivation = 'click' | 'modifier-click'

const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi
const TRAILING_PUNCTUATION = '.,;:!?\'"'
const CLOSING_BRACKETS: Record<string, string> = {
  ')': '(',
  ']': '[',
  '}': '{',
}

const countChar = (value: string, char: string) => value.split(char).length - 1

const trimTrailing = (url: string) => {
  let result = url
  while (result.length > 0) {
    const last = result[result.length - 1]
    const opening = CLOSING_BRACKETS[last]
    const isUnbalancedBracket =
      opening !== undefined &&
      countChar(result, last) > countChar(result, opening)
    if (!TRAILING_PUNCTUATION.includes(last) && !isUnbalancedBracket) break
    result = result.slice(0, -1)
  }
  return result
}

export const findTextLinks = (text: string): TextLink[] =>
  Array.from(text.matchAll(URL_PATTERN)).flatMap((match) => {
    const url = trimTrailing(match[0])
    if (!url.includes('.')) return []
    const start = match.index ?? 0
    const href = /^www\./i.test(url) ? `https://${url}` : url
    return [{ start, end: start + url.length, href }]
  })

export const isLinkModifierPressed = (event: {
  metaKey: boolean
  ctrlKey: boolean
}) => event.metaKey || event.ctrlKey

export const openTextLink = (link: TextLink) => {
  window.open(link.href, '_blank', 'noopener,noreferrer')
}
